import React from 'react';
import { Badge } from 'reactstrap';
import moment from 'moment';
import Can from '../../../../../components/Core/Can';

const statusColors: Record<string, string> = {
  PENDING: 'warning',
  APPROVED: 'success',
  REJECTED: 'danger',
};

const columns = ({
  setDeductionDetailsData,
  setIsDeductionDetailsOpen,
  onApprove,
  onReject,
}: {
  setDeductionDetailsData: any;
  setIsDeductionDetailsOpen: any;
  onApprove?: (row: any) => void;
  onReject?: (row: any) => void;
}) => {
  return [
    {
      name: 'Name',
      grow: 2,
      cell: (row: any) => (
        <div
          className="d-flex align-items-center"
          style={{
            cursor: 'pointer',
            transition: 'filter 0.3s ease',
            filter: 'brightness(1)',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.filter = 'brightness(0.8)')}
          onMouseLeave={(e) => (e.currentTarget.style.filter = 'brightness(1)')}
          onClick={() => {
            setDeductionDetailsData(row);
            setIsDeductionDetailsOpen(true);
          }}
        >
          <div style={{ width: '35px', height: '35px', borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
            <img
              src={row.user.picture}
              alt="User Profile"
              className="img-fluid"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <span className="ml-2 text-primary font-weight-bold text-sm">{`${row.user.firstName || '-'} ${
            row.user.lastName || '-'
          }`}</span>
        </div>
      ),
    },
    {
      name: 'Type',
      selector: (row: any) => row.type,
      grow: 1,
      cell: (row: any) => row.type,
    },
    {
      name: 'Total Amount',
      selector: (row: any) => (row.amount ? `$ ${parseFloat(row.amount).toFixed(2)}` : ''),
      grow: 2,
      cell: (row: any) => (row.amount ? `$ ${parseFloat(row.amount).toFixed(2)}` : ''),
    },
    {
      name: 'Date',
      selector: (row: any) => moment(row.startDate).format('MMMM D, YYYY'),
      grow: 1,
      cell: (row: any) => moment(row.startDate).format('MMMM D, YYYY'),
    },
    {
      name: 'Amount Paid',
      selector: (row: any) => `$ ${parseFloat(row.amountPaid || 0).toFixed(2)}`,
      grow: 1,
      cell: (row: any) => `$ ${parseFloat(row.amountPaid || 0).toFixed(2)}`,
    },
    {
      name: 'Amount Left',
      selector: (row: any) => `$ ${parseFloat(row.amountLeft ?? row.amount ?? 0).toFixed(2)}`,
      grow: 1,
      cell: (row: any) => `$ ${parseFloat(row.amountLeft ?? row.amount ?? 0).toFixed(2)}`,
    },
    {
      name: 'End Date',
      selector: (row: any) => (row.endDate ? moment(row.endDate).format('MMMM D, YYYY') : ''),
      grow: 1,
      cell: (row: any) => (row.endDate ? moment(row.endDate).format('MMMM D, YYYY') : ''),
    },
    {
      name: 'Status',
      selector: (row: any) => row.status,
      grow: 1,
      cell: (row: any) => (
        <Badge color={statusColors[row.status] || 'secondary'} pill>
          {row.status || '-'}
        </Badge>
      ),
    },
    {
      name: 'Actions',
      width: '140px',
      cell: (row: any) => (
        <div className="d-flex align-items-center" style={{ gap: '6px' }}>
          <button
            type="button"
            className="btn btn-link p-0"
            title="View"
            onClick={() => {
              setDeductionDetailsData(row);
              setIsDeductionDetailsOpen(true);
            }}
          >
            <i className="fas fa-eye text-info" />
          </button>
          {row.status === 'PENDING' && (
            <Can moduleName="Deduction" functionName="Approve">
              <button type="button" className="btn btn-link p-0" title="Approve" onClick={() => onApprove?.(row)}>
                <i className="fas fa-check text-success" />
              </button>
              <button type="button" className="btn btn-link p-0" title="Reject" onClick={() => onReject?.(row)}>
                <i className="fas fa-ban text-danger" />
              </button>
            </Can>
          )}
        </div>
      ),
    },
  ];
};

export default columns;
